var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowFillInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70015 8.00711C6.45041 8.00701 6.2035 7.9543 5.97549 7.85242C5.74748 7.75053 5.5435 7.60176 5.37682 7.41578L1.08948 3.06645C0.899113 2.86538 0.771838 2.61294 0.723392 2.34032C0.674945 2.0677 0.707451 1.78686 0.816892 1.53251C0.926332 1.27817 1.10791 1.06147 1.33918 0.909207C1.57044 0.756944 1.84126 0.675792 2.11815 0.675781H11.2822C11.5568 0.675926 11.8255 0.755911 12.0555 0.905999C12.2856 1.05609 12.467 1.26981 12.5778 1.52114C12.6885 1.77248 12.7238 2.0506 12.6794 2.32164C12.635 2.59269 12.5127 2.84497 12.3275 3.04778L8.00282 7.44045C7.83695 7.6202 7.63546 7.76343 7.41117 7.86099C7.18689 7.95856 6.94473 8.00832 6.70015 8.00711Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowFillInactive);
export default __webpack_public_path__ + "static/media/down-arrow-fill-inactive.bcfb6905301f1e14b8533a1968005d07.svg";
export { ForwardRef as ReactComponent };